import { useSelector } from 'react-redux';
import { isAppModule } from '@utils/constants';
import { checkFeature } from '@utils/platform/features/checkFeature';
import {
  appLiveModeOnTrendsSelector,
  realTimeOnTrendsFeatureSelector,
} from '@store/common/selectors';
import { compareOnTrendsModeSelector } from '@store/trends/base/selectors';
import { isPolicyMode } from '@src/pages/TrackingPolicy/utils/helper';

function useShowLiveMode() {
  // TODO: in such scenarios where it means the same thing but only the state key is different
  // make the change in the selector to switch state keys based on app
  // so that rest of the code doesn't have to change
  const isLiveModeOnTrendsEnabled = useSelector(realTimeOnTrendsFeatureSelector);
  const isAppLiveModeOnTrendsEnabled = useSelector(appLiveModeOnTrendsSelector);

  const compareMode = useSelector(compareOnTrendsModeSelector);
  const policyTrackingMode = isPolicyMode();

  return checkFeature(
    'trends.base.live-mode',
    !policyTrackingMode &&
      !compareMode &&
      (isAppModule ? isAppLiveModeOnTrendsEnabled : isLiveModeOnTrendsEnabled),
  );
}

export default useShowLiveMode;
